'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _radio = require('../components/radio');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Convictions(props) {
  return _react2.default.createElement(_radio.RadioYesNo, {
    name: 'convictions',
    label: 'Have you been charged or convicted of any motoring or criminal offence (unspent under the rehabilitation of offenders act 1974) within the last 5 years, or is any such prosecution pending?',
    helpText: 'Including fixed penalty offences such as speeding convictions.'
  });
}
exports.default = Convictions;